const shouldUsePrebinding = ({ componentValueKey, componentSettings, patternProperties, variable, }) => {
    const { patternPropertyDefinitions, variableMappings } = componentSettings;
    const variableMapping = variableMappings?.[componentValueKey];
    const patternPropertyDefinition = patternPropertyDefinitions?.[variableMapping?.patternPropertyDefinitionId || ''];
    const patternProperty = patternProperties?.[variableMapping?.patternPropertyDefinitionId || ''];
    const isValidForPrebinding = !!patternPropertyDefinition && !!patternProperty && !!variableMapping;
    return isValidForPrebinding && variable?.type === 'NoValue';
};
const resolvePrebindingPath = ({ componentValueKey, componentSettings, patternProperties, }) => {
    const variableMapping = componentSettings.variableMappings?.[componentValueKey];
    if (!variableMapping)
        return '';
    const patternProperty = patternProperties?.[variableMapping.patternPropertyDefinitionId];
    if (!patternProperty)
        return '';
    const contentType = patternProperty.contentType;
    const fieldPath = variableMapping?.pathsByContentType?.[contentType]?.path;
    if (!fieldPath)
        return '';
    return patternProperty.path + fieldPath;
};

export { resolvePrebindingPath, shouldUsePrebinding };
//# sourceMappingURL=prebindingUtils.js.map
